import { render, staticRenderFns } from "./CardSocialAnalytics.vue?vue&type=template&id=74ab7ecf&"
import script from "./CardSocialAnalytics.vue?vue&type=script&lang=js&"
export * from "./CardSocialAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports